export default __webpack_public_path__ + "static/img_interviewee_blee-df2b1b254147396c5748f5b3cfec59cf.png";